var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvgX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5385_3085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30615 20.2778C8.70103 20.2887 9.06533 20.0658 9.23584 19.7094L15.0356 7.58249L17.2935 12.5132L17.3638 12.6411C17.5462 12.9227 17.8606 13.0971 18.2026 13.0971H23.0005L23.103 13.0923C23.6072 13.0409 24.0005 12.6148 24.0005 12.0971C24.0004 11.5795 23.6071 11.1533 23.103 11.102L23.0005 11.0971H18.8442L15.9653 4.80613C15.8039 4.45334 15.4529 4.22559 15.0649 4.22214C14.6769 4.21887 14.3213 4.44046 14.1538 4.7905L8.40186 16.8178L6.30225 11.7163C6.14788 11.3418 5.78256 11.0971 5.37744 11.0971H1.00049C0.44824 11.0971 0.00054696 11.5449 0.000488281 12.0971C0.000488281 12.6494 0.448204 13.0971 1.00049 13.0971H4.7085L7.40869 19.6587L7.4751 19.7895C7.64857 20.0808 7.9606 20.2682 8.30615 20.2778Z",
    className: "Icon-fill-color"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5385_3085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgX2);
export default __webpack_public_path__ + "static/media/AvgX2.3b1e143151b7cf4a43c1e2320c57e99e.svg";
export { ForwardRef as ReactComponent };